<template>
  <div>
    <van-nav-bar
        title="注册"
        left-arrow
        @click-left="onClickLeft"
    />
    <van-cell-group>
      <van-field v-model="clients.userName" label="手机号" placeholder="请输入手机号"/>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="clients.password" label="密码" placeholder="请输入密码"/>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="clients.newpwass" label="确认密码" placeholder="请再次输入密码"/>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="clients.name" label="公司名" placeholder="请输入公司名"/>
    </van-cell-group>
    <van-cell-group>
      <van-field v-model="clients.addr" label="地址" placeholder="请输入地址"/>
    </van-cell-group>
    <div class="login-btn">
      <nut-button block class="landing" @click="addManage">
        注册
      </nut-button>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import {Toast} from 'vant'
const CryptoJS = require("crypto-js")

function encrypt (data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  name: "Register",
  data () {
    return {
      clients: {
        name: '',
        userName: '',
        addr: '',
        password: '',
        newpwass: ""
      },
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go("-1")
    },
    addManage () {
      this.$ajax({
        url: '/etv/registerPersoner.json',
        method: 'post',
        data: {
          userInfo: encrypt(JSON.stringify(this.clients)),
        },    //this.clients,
        cache: false,
        transformRequest: [function (data) {
          if (data instanceof FormData) {
            return data
          }
          data = qs.stringify(data)
          return data
        }],

      }).then(res => {
        if (res.data.code === 0) {
          Toast(res.data.msg)
          this.$router.replace("/login")
        } else {
          Toast(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../public/static/css/app";
.login-btn {
  padding: 0 40px;
  margin-top: 15px;

  .landing {
    border-radius: 3px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 3px;
    color: $uni-text-color-inverse;
    background: $uni-color-primary;
  }
}
</style>
